import { DOCUSIGN_IMPLEMENTATION, OPENSTATE_RESPONSE_TYPES } from '../constants/steps';

const actionTypes = require('constants/actionTypes');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const formActions = require('react-redux-form').actions;
import { getLanguage } from 'core/i18n';

const forceLogaltyTransactionRefresh = (requestData, callback) => {
    const url = apiURLBuilder.getURL('logaltyTransactionRefresh');
    Api.post(url, requestData).then(() => {
        setTimeout(() => {
            callback();
        }, 20000);
    });
};

const refreshLogaltyTransaction = (accessToken, guid, callback) => {
    return () => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {
                guid,
            },
        };

        forceLogaltyTransactionRefresh(requestData, callback);
    };
};

const getImplementation = (dispatch, requestData, onError) => {
    const url = apiURLBuilder.getURL('getOnboardingImplementation');
    Api.get(url, requestData).then(
        response => {
            dispatch({
                type: actionTypes.SET_ONBOARDING_IMPLEMENTATION,
                implementation: response.body ? response.body.implementation : DOCUSIGN_IMPLEMENTATION,
            });
        },
        () => {
            onError();
        }
    );
};

// Endpoint to get onboarding implementation, the returned value could be Logalty or Docusign
const getOnboardingImplementation = (accessToken, onError) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        getImplementation(dispatch, requestData, onError);
    };
};

const getContractStatusService = (dispatch, requestData, isLogalty, contractToken) => {
    const url = isLogalty
        ? apiURLBuilder.getURL('logaltyContractStatus', { contractToken })
        : apiURLBuilder.getURL('getContract');
    Api.get(url, requestData).then(response => {
        if (response.body) {
            const data = {
                status: response.body.status.toLowerCase(),
                onboardingStatus: response.body.onboardingStatus.toLowerCase(),
                lastUpdate: response.body.lastUpdate,
            };

            dispatch(formActions.change('userProfile.contract', data.status));
            dispatch(formActions.change('userProfile.status', data.onboardingStatus));
            dispatch({
                type: actionTypes.CONTRACT_STATUS,
                data,
            });
        }
    });
};

const getContractStatus = (accessToken, isLogalty, contractToken) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };
        getContractStatusService(dispatch, requestData, isLogalty, contractToken);
    };
};

const confirmContractService = (dispatch, requestData, status, callback) => {
    if (!status) {
        const url = apiURLBuilder.getURL('confirmContract');
        Api.post(url, requestData).then(response => {
            if (response.body) {
                dispatch(formActions.change('userProfile.documentation', 'ready'));
                callback(response.body);
            }
        });
    } else {
        callback();
    }
};

const confirmContract = (status, accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };

        confirmContractService(dispatch, requestData, status, callback);
    };
};

function createContractDelay(dispatch, requestData, callback, countError, isLogalty = false, statusCode) {
    let counter = countError;

    let timeout;

    if (isLogalty) {
        if (statusCode !== 504) {
            timeout = 100;
        } else {
            timeout = counter === 0 ? 35000 : counter * 10000;
        }
    } else {
        timeout = counter * 10000;
    }

    if (counter < 10) {
        setTimeout(() => {
            counter++;
            createContractService(dispatch, requestData, callback, counter, isLogalty); // eslint-disable-line
        }, timeout);
    } else {
        callback(true, true, false);
    }
}

function createContractService(dispatch, requestData, callback, countError, isLogalty = false) {
    const url = isLogalty ? apiURLBuilder.getURL('logaltyContractCreate') : apiURLBuilder.getURL('contractCreateV2');
    Api.post(url, requestData).then(
        response => {
            if (response.body) {
                const data = response.body;
                if (data.status !== 'OK') {
                    createContractDelay(dispatch, requestData, callback, countError, isLogalty);
                } else {
                    dispatch({
                        type: actionTypes.CONTRACT_URL,
                        data,
                    });

                    const executeCallback = () => {
                        dispatch({
                            type: actionTypes.CONTRACT_LOADED,
                        });
                        callback(false, false, false);
                    };

                    isLogalty ? executeCallback() : setTimeout(executeCallback, 10000);
                }
            }
        },
        error => {
            let continueService = true;

            if (error.body) {
                if (error.body.error && error.body.error === 'invalid_token') {
                    continueService = false;
                }
                if (error.body.status && error.body.status === 'Error' && error.body.errors['6002']) {
                    continueService = false;
                }
            }

            if (continueService) {
                createContractDelay(dispatch, requestData, callback, countError, isLogalty, error.statusCode);
            } else {
                callback(true, false, error);
            }
        }
    );
}

const createContract = (accessToken, callback, isLogalty) => {
    return function (dispatch) {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
                Language: getLanguage(),
            },
            query: {},
        };
        createContractService(dispatch, requestData, callback, 0, isLogalty);
    };
};

const changeToLoadingContract = dispatch => {
    dispatch({ type: actionTypes.CONTRACT_LOADING });
};

const loadingContract = () => {
    return dispatch => {
        changeToLoadingContract(dispatch);
    };
};

const fetchOpenStateStatus = (requestData, accessToken, contractToken, guid, onError, counter) => {
    const url = apiURLBuilder.getURL('getOpenStateStatus', { contractToken });
    if (counter === 4) return;

    const callback = () => {
        fetchOpenStateStatus(requestData, accessToken, contractToken, guid, onError, counter + 1);
    };

    const handleEmptyOrError = () => {
        if (counter === 0) {
            refreshLogaltyTransaction(accessToken, guid, callback)();
        } else {
            setTimeout(() => {
                fetchOpenStateStatus(requestData, accessToken, contractToken, guid, onError, counter + 1);
            }, 10000);
        }
    };

    Api.get(url, requestData)
        .then(response => {
            if (response.body) {
                const openStateDescription = response.body.openStateDescription.toUpperCase();

                switch (openStateDescription) {
                    case OPENSTATE_RESPONSE_TYPES.FAIL:
                        if (counter === 0) {
                            refreshLogaltyTransaction(accessToken, guid, callback)();
                        } else {
                            onError();
                        }
                        break;
                    case OPENSTATE_RESPONSE_TYPES.EMPTY:
                        handleEmptyOrError();
                        break;
                    case OPENSTATE_RESPONSE_TYPES.IN_PROGRESS:
                        setTimeout(() => {
                            fetchOpenStateStatus(requestData, accessToken, contractToken, guid, onError, counter + 1);
                        }, 10000);
                        break;
                    case OPENSTATE_RESPONSE_TYPES.SUCCESS:
                        break;
                    default:
                        onError();
                        break;
                }
            }
        })
        .catch(handleEmptyOrError);
};

const getOpenStateStatus = (accessToken, contractToken, guid, onError, counter = 0) => {
    return function () {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: {},
        };
        fetchOpenStateStatus(requestData, accessToken, contractToken, guid, onError, counter);
    };
};

export default {
    getContractStatus,
    confirmContract,
    createContract,
    loadingContract,
    getOnboardingImplementation,
    refreshLogaltyTransaction,
    getOpenStateStatus,
};
